import React, { PureComponent, Fragment } from 'react'
import { Grid, ListItem, Paper, Switch, MenuItem } from '@material-ui/core'
import {
  EditableTextField,
  EditableReactSelect,
  EditableSwitch,
  EditableDateInput,
  EditableSelect,
} from '../common/EditableComponents'
import { convertArrayToOptions } from '../../utils/array'
import { getSession, getActiveUserRole } from '../../utils/api'
import { roles } from '../../utils/constants'
import moment from 'moment'
import ReactPhoneInput from '../common/ReactPhoneInput'
import { getUsStates } from '../../utils/constants'

export default class EmployeeCredentials extends PureComponent {
  state = {
    note:
      this.props.data && this.props.data.notes && this.props.data.notes.length > 0
        ? this.props.data.notes[0].message
        : '',
  }
  onChange = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target ? e.target.value : e.valueOf()
    this.props.onChange(key, value)
  }

  onSelectChange = (key, input) => {
    this.props.onChange(key, input.value)
  }

  onChangeShops = (shopId, isAdminEmployee) => (event) => {
    if (this.props.editMode && !isAdminEmployee) {
      const { shops = [] } = this.props.data || {}

      let updatedShops = [...shops]

      if (event.target.checked) {
        updatedShops = [...updatedShops, shopId]
      } else {
        const shopIndex = updatedShops.findIndex((shop) => shop === shopId)
        updatedShops.splice(shopIndex, 1)
      }

      this.props.onChange('shops', updatedShops)
    }
  }

  onChangeAllshops = (isAdminEmployee) => (event) => {
    if (this.props.editMode && !isAdminEmployee) {
      const { shops = [] } = this.props || {}

      let updatedShops = []
      if (event.target.checked) {
        shops.map((shop) => {
          updatedShops = [...updatedShops, shop.id]
        })
      } else {
        updatedShops = []
      }

      this.props.onChange('shops', updatedShops)
    }
  }

  onChangeNote = (e) => {
    this.setState({ note: e.target.value })
    let arr = []
    arr.push({ message: this.state.note })
    this.props.onChange('notes', arr)
  }

  canEditPin = () => {
    const activeUserRole = getActiveUserRole()
    return activeUserRole.name === roles.ADMIN || activeUserRole.name === roles.MANAGER
  }

  onChangePhone = (e, key) => {
    this.props.onChange(key, e)
  }

  onChangeAddress = (key) => (e) => {
    const { data } = this.props
    const { address } = data

    let newAddress = { ...address }

    newAddress = {
      ...newAddress,
      [key]: e.target.value,
    }

    if (key === 'country') {
      newAddress = {
        ...newAddress,
        state: '',
      }
    }
    this.props.onChange('address', newAddress)
  }

  render() {
    const {
      data = {},
      shops = [],
      editMode = false,
      errors,
      isInvite = false,
      dbRoles = [],
    } = this.props
    const isEmployee = data && data.id ? true : false
    let terminalOptions = convertArrayToOptions(this.props.terminals.filter((term) => term.active))
    let selectedTerminal =
      terminalOptions.find((term) => term.value === data.assignedTerminalId) || {}
    const states = getUsStates()
    //console.log(data && data.notes, "notes")
    const session = getSession()
    let info = { label: 'Unassigned', value: 'Unassigned' }
    terminalOptions.unshift(info)
    const canEditPin = !isEmployee || this.canEditPin()

    const isCompliance =
      session && session.assignedShop && session.assignedShop.complianceType === 'BIOTRACK'

    const adminRole = dbRoles && dbRoles.find((dbRole) => dbRole.name == roles.ADMIN)
    const isAdminEmployee = adminRole && adminRole.id == data.roleId

    return (
      <Fragment>
        <Paper className="paper-page">
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                Hire Date
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                <EditableDateInput
                  className="emp-date-picker"
                  isValidDate={this.isValidDate}
                  valueToRender={
                    (!!data.hireDate && moment(parseInt(data.hireDate)).format('MM/DD/YYYY')) || ''
                  }
                  editMode={editMode}
                  value={
                    (!!data.hireDate && moment(parseInt(data.hireDate)).format('MM/DD/YYYY')) || ''
                  }
                  onChange={this.onChange('hireDate', false)}
                  type="text"
                  dateFormat={'MM/DD/YYYY'}
                  closeOnSelect={true}
                  timeFormat={false}
                  inputProps={{ placeholder: 'MM/DD/YYYY' }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                DOB
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                <EditableDateInput
                  className="emp-date-picker"
                  isValidDate={this.isValidDate}
                  valueToRender={
                    (!!data.birthDate && moment(parseInt(data.birthDate)).format('MM/DD/YYYY')) ||
                    ''
                  }
                  editMode={editMode}
                  value={
                    (!!data.birthDate && moment(parseInt(data.birthDate)).format('MM/DD/YYYY')) ||
                    ''
                  }
                  onChange={this.onChange('birthDate', false)}
                  type="text"
                  dateFormat={'MM/DD/YYYY'}
                  closeOnSelect={true}
                  timeFormat={false}
                  inputProps={{ placeholder: 'MM/DD/YYYY' }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                Phone
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                {editMode ? (
                  <ReactPhoneInput
                    defaultCountry={'us'}
                    placeholder={'Phone Number'}
                    onChange={(e) => this.onChangePhone(e, 'phoneNumber')}
                    preferredCountries={['us', 'ca']}
                    inputClass="global-phone-input"
                    name="phoneNumber"
                    value={(data && data.phoneNumber) || ''}
                    containerClass="form-control phone-input"
                  />
                ) : (
                  `${data && data.phoneNumber}`
                )}
                {/* <EditableInput
                                    valueToRender={data.phoneNumber}
                                    editMode={editMode}
                                    value={data.phoneNumber}
                                    onChange={this.onChange('phoneNumber')}
                                    id="formatted-text-mask-input"
                                    inputComponent={PhoneMask}
                                    className="form-control"
                                /> */}
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                Email*
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                <EditableTextField
                  valueToRender={data.email || ''}
                  editMode={editMode}
                  value={data.email}
                  onChange={this.onChange('email')}
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.email}
                  helperText={errors.email}
                />
              </Grid>
            </Grid>
          </ListItem>
          {!isInvite ? (
            <Fragment>
              {data && !data.id ? (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Password*
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.password || ''}
                        editMode={editMode}
                        value={data.password}
                        onChange={this.onChange('password')}
                        type="password"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={errors.password}
                        helperText={errors.password}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              ) : null}
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Pin*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.pin || ''}
                      editMode={editMode && canEditPin}
                      value={data.pin}
                      onChange={this.onChange('pin')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.pin}
                      helperText={errors.pin}
                    />
                  </Grid>
                </Grid>
              </ListItem>
            </Fragment>
          ) : null}
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                Address
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                <EditableTextField
                  valueToRender={(data.address && data.address.address) || ''}
                  editMode={editMode}
                  value={(data.address && data.address.address) || ''}
                  onChange={this.onChangeAddress('address')}
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                City
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                <EditableTextField
                  valueToRender={(data.address && data.address.city) || ''}
                  editMode={editMode}
                  value={(data.address && data.address.city) || ''}
                  onChange={this.onChangeAddress('city')}
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                State
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                <EditableSelect
                  value={(data.address && data.address.state) || ''}
                  onChange={this.onChangeAddress('state')}
                  valueToRender={(data.address && data.address.state) || ''}
                  editMode={editMode}
                >
                  {states.map((state) => {
                    return (
                      <MenuItem key={state.value} value={state.value}>
                        {state.label}
                      </MenuItem>
                    )
                  })}
                </EditableSelect>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                Zipcode
              </Grid>
              <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                <EditableTextField
                  valueToRender={(data.address && data.address.zipCode) || ''}
                  editMode={editMode}
                  value={data.address && data.address.zipCode}
                  onChange={this.onChangeAddress('zipCode')}
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </ListItem>
          {isCompliance && (
            <ListItem>
              <Grid container>
                <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                  Create Employee in BioTrack?
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <EditableSwitch
                    valueToRender={data.biotrack ? 'Yes' : 'No'}
                    editMode={editMode}
                    checked={data.biotrack}
                    onChange={this.onChange('biotrack', true)}
                  />
                </Grid>
              </Grid>
            </ListItem>
          )}
          {data.biotrack ? (
            <ListItem>
              <Grid container>
                <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                  Transaction ID BioTrack
                </Grid>
                <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                  {data.biotrackTransId}
                </Grid>
              </Grid>
            </ListItem>
          ) : (
            <div />
          )}
        </Paper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Employees/EmployeeCredentials.js